(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name DonationsController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('DonationsController', DonationsController);

    DonationsController.$inject = ['$uibModal','$timeout','$http','UserService','AddressService','StripeService','$scope'];


    function DonationsController($uibModal,$timeout,$http,UserService,AddressService,StripeService,$scope)
    {
		    
    var vm = this;
    vm.paymentModal = "";
    vm.donation = []; 
    vm.swapDonation = []; 
    vm.custom = [];

    vm.as = AddressService;
    vm.stripe = StripeService;
		vm.amount = 0;
		vm.errorAmount = false;
		  

      $scope.$watch("dc.donation",function(newValue,oldValue) {
        console.log("DONATION");

        vm.setAmount();

      } , true );
		

  		vm.setAmount = function(){
	  		vm.amount = 0 ;
		  	angular.forEach(vm.donation,function(value,key){
			  	vm.amount = vm.amount + parseInt(value);
			  });
		  };

    	vm.updatePrices = function(val,cat)
      {
        console.log(val);
        console.log(cat);
        console.log(this);
        var isOther = false;
        if(val=='other')
        {
          val = vm.donation[cat];
          isOther = true;

        }

          if(vm.swapDonation[cat]!==val)
          {
            vm.swapDonation[cat] = val;
          }else{

            if(isOther)
              vm.custom[cat]=1;

            vm.swapDonation[cat] = 0;
            vm.donation[cat]=0;
          }

        
        console.log(vm.donation);
      };

      vm.submit = function()
      {
        vm.errorAmount = false;

        vm.setAmount();

        if(vm.amount>0 && vm.stripe.fullname !== "" && !vm.stripe.cardError )
        {
          vm.stripe.setProducts(vm.donation);
          vm.stripe.setAmount(vm.amount);
          vm.stripe.submitForm().then(function(){
             vm.amount = 0;
             angular.forEach(vm.donation,function(value,key){
                vm.donation[key] = 0;
             });
          });
        }
        else{
          vm.errorAmount = true;
        }

      };


      vm.as.reloadAddresses();
      vm.stripe.init();

    }
})();